<template>
    <div class="restart">
         <a v-on:click.prevent="restart()" href="/">Start på nytt</a>
    </div>
</template>

<script setup>
import { defineEmits } from 'vue';

const emit = defineEmits(['restart']);

const restart = () => {        

    if(confirm("Er du sikker på at du vil starte på nytt? Alle valg og endringer blir borte.")){        
        emit('restart');                 
    }

    
};

</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
.restart {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;
    padding: 0 5%;    
}
</style>
